"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPriceDropAlertResponseDto = instanceOfPriceDropAlertResponseDto;
exports.PriceDropAlertResponseDtoFromJSON = PriceDropAlertResponseDtoFromJSON;
exports.PriceDropAlertResponseDtoFromJSONTyped = PriceDropAlertResponseDtoFromJSONTyped;
exports.PriceDropAlertResponseDtoToJSON = PriceDropAlertResponseDtoToJSON;
exports.PriceDropAlertResponseDtoToJSONTyped = PriceDropAlertResponseDtoToJSONTyped;
/**
 * Check if a given object implements the PriceDropAlertResponseDto interface.
 */
function instanceOfPriceDropAlertResponseDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('userId' in value) || value['userId'] === undefined)
        return false;
    if (!('listingId' in value) || value['listingId'] === undefined)
        return false;
    if (!('alertPrice' in value) || value['alertPrice'] === undefined)
        return false;
    if (!('isActive' in value) || value['isActive'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    return true;
}
function PriceDropAlertResponseDtoFromJSON(json) {
    return PriceDropAlertResponseDtoFromJSONTyped(json, false);
}
function PriceDropAlertResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'userId': json['userId'],
        'listingId': json['listingId'],
        'alertPrice': json['alertPrice'],
        'isActive': json['isActive'],
        'createdAt': json['createdAt'],
    };
}
function PriceDropAlertResponseDtoToJSON(json) {
    return PriceDropAlertResponseDtoToJSONTyped(json, false);
}
function PriceDropAlertResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'userId': value['userId'],
        'listingId': value['listingId'],
        'alertPrice': value['alertPrice'],
        'isActive': value['isActive'],
        'createdAt': value['createdAt'],
    };
}
